import { createContext, useContext, useEffect, useRef, useState } from "react";
import axios from "axios";
import { API } from "../../lib/constants";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH

const AuthContext = createContext({ user: null, authLoading: true, login: () => {}, logout: () => {} });
export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [authLoading, setAuthLoading] = useState(true);
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = window.location.hash || "";
    if (hash.includes("session_id=")) {
      const sessionId = hash.split("session_id=")[1].split("&")[0];
      // Land inside the observatory (not the landing page) after sign-in
      sessionStorage.setItem("aioo_entered", "1");
      window.history.replaceState(null, "", window.location.pathname + window.location.search);
      axios.post(`${API}/auth/session`, { session_id: sessionId }, { withCredentials: true })
        .then(res => { setUser(res.data); localStorage.setItem("aioo_authed", "1"); })
        .catch(() => {})
        .finally(() => setAuthLoading(false));
      return;
    }
    // Only probe /auth/me when this browser has signed in before — keeps the
    // console free of expected 401s for anonymous visitors.
    if (!localStorage.getItem("aioo_authed")) {
      setAuthLoading(false);
      return;
    }
    axios.get(`${API}/auth/me`, { withCredentials: true })
      .then(res => setUser(res.data))
      .catch(() => { localStorage.removeItem("aioo_authed"); })
      .finally(() => setAuthLoading(false));
  }, []);

  const login = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin;
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  const logout = async () => {
    try { await axios.post(`${API}/auth/logout`, {}, { withCredentials: true }); } catch { /* noop */ }
    localStorage.removeItem("aioo_authed");
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, authLoading, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};
